// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "5bb0f8c12d0017947df0" + ".chunk.js";
};